<template>
  <v-resource-list
    :loading="loading"
    :items="items"
    :attach="attach"
    :attach-items="pageTypes.data"
    :hide-pagination="hidePagination"
    @paginate="fetchResource"
    @viewResource="viewResource"
    @editResource="editResource"
    @deleteResource="deleteResource"
    @attachResource="attachResource"
  >
    <template slot="headings">
      <th class="text-left">Name</th>
      <th class="text-left">Page Type Group</th>
      <th class="text-left">Ready</th>
      <th class="text-left">WP Ready</th>
    </template>
    <template slot-scope="{ item }">
      <td>{{ get(item, 'name', get(item, 'pageType.name')) }}</td>
      <td>
        <router-link
          :to="{
            name: 'page-type-groups.view',
            params: { id: get(item, 'page_type_group_id', get(item, 'pageType.page_type_group_id')) },
          }"
        >
          {{ get(item, 'pageTypeGroup.name', get(item, 'pageType.page_type_group_id')) }}
        </router-link>
      </td>
      <td>
        <tick-or-cross :value="new Boolean(get(item, 'is_ready', get(item, 'pageType.is_ready')))" />
      </td>
    </template>
  </v-resource-list>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import ListResourceHandler from '@/mixins/list-resource-handler'
export default {
  mixins: [ListResourceHandler],
  data: () => ({ attachMethod: 'fetchPageTypes' }),
  computed: {
    ...mapGetters({
      entityTypePageTypes: 'entityTypePageTypes/getEntityTypePageTypes',
      pageTypeSiteGroups: 'pageTypeSiteGroups/getPageTypeSiteGroups',
      pageTypes: 'pageTypes/getPageTypes',
    }),
  },
  methods: {
    ...mapActions({
      fetchPageTypeSiteGroups: 'pageTypeSiteGroups/fetch',
      fetchEntityTypePageTypes: 'entityTypePageTypes/fetch',
      fetchPageTypes: 'pageTypes/fetch',
      attachEntityTypePageTypes: 'entityTypePageTypes/attach',
      attachPageTypeSiteGroups: 'pageTypeSiteGroups/attach',
      deleteEntityTypePageTypes: 'entityTypePageTypes/detach',
      deletePageTypeSiteGroups: 'pageTypeSiteGroups/detach',
      deletePageTypes: 'pageTypes/delete',
    }),
    viewResource(item) {
      this.$router.push({
        name: 'page-types.manage',
        params: { id: item.page_type_id || item.pageType.id || null },
      })
    },
    editResource(item) {
      this.$router.push({
        name: 'page-types.manage',
        params: { id: item.page_type_id || item.pageType.id || null },
      })
    },
  },
}
</script>
